import { create } from 'zustand';

export const useFormTaskStore = create((set) => ({
    tasks: [],
    waitingTasks: [],
    myTasks: [],
    myWorkInbox: [],
    selectedTask: null,
    totalCount: 0,
    waitingTotalCount: 0,
    myTotalCount: 0,
    myWorkInboxTotal: 0,
    loading: false,
    error: null,

    setTasks: (tasks) => set({ tasks }),
    setWaitingTasks: (waitingTasks) => set({ waitingTasks }),
    setMyTasks: (myTasks) => set({ myTasks }),
    setMyWorkInbox: (myWorkInbox) => set({ myWorkInbox }),
    setSelectedTask: (task) => set({ selectedTask: task }),
    clearSelectedTask: () => set({ selectedTask: null }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearStore: () => set({
        tasks: [], waitingTasks: [], myTasks: [], myWorkInbox: [],
        selectedTask: null, totalCount: 0,
        waitingTotalCount: 0, myTotalCount: 0, myWorkInboxTotal: 0, error: null
    }),
}));
